// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AdminEyefinityFeeLensRequest } from './admin-eyefinity-fee-lens-request';

// @ts-ignore
import { AdminEyefinityFeeOptionRequest } from './admin-eyefinity-fee-option-request';

// @ts-ignore
import { AdminEyefinityFeeServiceRequest } from './admin-eyefinity-fee-service-request';

/** See com.rev360.pms.api.controller.admin.accounting.eyefinity.AdminEyefinityFeeScheduleRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminEyefinityFeeScheduleRequest extends GandalfModelBase {

	@GandalfArray(AdminEyefinityFeeLensRequest)
	baseLenses!: AdminEyefinityFeeLensRequest[] | null;

	@GandalfLabel('Begin Date')
	@GandalfValidator({ notNull: { message: 'Begin Date is required' } })
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date, isRequired: true })
	beginDate!: Date;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('CL Fitting % Covered')
	@GandalfValidator({ min: { min: 0, message: 'CL Fitting % Covered must be between 0 and 100' } })
	@GandalfValidator({ max: { max: 100, message: 'CL Fitting % Covered must be between 0 and 100' } })
	@GandalfValidator({ notNull: { message: 'CL Fitting % Covered is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	contactLensExamPercentage!: number;

	@GandalfLabel('End Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	endDate!: Date | null;

	@GandalfLabel('Frame Service Fee')
	@GandalfValidator({ notNull: { message: 'Frame Service Fee is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	frameDispensingFee!: number;

	@GandalfArray(AdminEyefinityFeeOptionRequest)
	lensAddons!: AdminEyefinityFeeOptionRequest[] | null;

	@GandalfLabel('Name')
	@GandalfValidator({ notNull: { message: 'Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Name must be between 1 and 255 characters', minLength: 1, maxLength: 255 } })
	@GandalfProperty({ designType: String, isRequired: true })
	name!: string;

	@GandalfLabel('Patient Copay')
	@GandalfValidator({ notNull: { message: 'Patient Copay is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientCopayReasonId!: number;

	@GandalfLabel('Payment Transfer')
	@GandalfValidator({ notNull: { message: 'Payment Transfer is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientTransferReasonId!: number;

	@GandalfLabel('Recoupment')
	@GandalfValidator({ notNull: { message: 'Recoupment is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	recoupmentReasonId!: number;

	@GandalfArray(AdminEyefinityFeeServiceRequest)
	services!: AdminEyefinityFeeServiceRequest[] | null;

	@GandalfLabel('Write-Off')
	@GandalfValidator({ notNull: { message: 'Write-Off is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	writeoffReasonId!: number;

}
